import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Customer} from './customer';

@Injectable()
export class CustomerService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('customers?' + params.toString()).map((response: Response) => response.json());
  }

  getAllCustomers() {
    return this.http.get('customers/all').map((response: Response) => response.json());
  }

  getAllInv() {
    return this.http.get('salesinv/all').map((response: Response) => response.json());
  }

  getAllPurchaseInv() {
    return this.http.get('prurchasinv/all').map((response: Response) => response.json());
  }

  getCustomername(_id: string){
    return this.http.get('customers/getname/'+_id).map((response: Response) => response.json());
  }


  getById(_id: string) {
    return this.http.get('customers/' + _id).map((response: Response) => response.json());
  }
  getTrashedById(_id: string) {
    return this.http.get('customers/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('customers/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(customer: Customer) {
    return this.http.post('customers', customer).map((response: Response) => response.json());
  }

  update(customer: Customer) {
    return this.http.put('customers/' + customer.id, customer).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('customers/' + _id);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/customers/customer.service.ts